var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8.065 13C5.126 13 2.622 11.405.581 8.273a.5.5 0 0 1-.003-.542C2.576 4.597 5.06 3 8 3c2.94 0 5.424 1.597 7.422 4.731a.5.5 0 0 1 .002.533C13.471 11.401 11.008 13 8.065 13zm0-1c2.487 0 4.591-1.314 6.34-3.997C12.615 5.317 10.49 4 8 4 5.513 4 3.388 5.315 1.599 7.997 3.429 10.683 5.576 12 8.065 12zM8 10.737c-1.563 0-2.833-1.216-2.833-2.737 0-1.523 1.272-2.75 2.833-2.75 1.56 0 2.833 1.227 2.833 2.75 0 1.521-1.27 2.737-2.833 2.737zm0-1c1.02 0 1.833-.778 1.833-1.737 0-.962-.816-1.75-1.833-1.75S6.167 7.038 6.167 8c0 .959.813 1.737 1.833 1.737z" })
  );
});